import Checkbox from '@components/v2/form/Checkbox/Checkbox';
import { MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps } from '@mui/material';
import { ReactNode } from 'react';

type Props = MuiMenuItemProps & {
  selected?: boolean;
  children: ReactNode;
};

const CheckboxMenuItem = ({ selected, children, ...rest }: Props) => (
  <MuiMenuItem {...rest} disableGutters selected={selected}>
    <Checkbox
      aria-hidden
      checked={selected}
      size="small"
      sx={{ pointerEvents: 'none', mr: 1 }}
      slotProps={{ input: { tabIndex: -1, readOnly: true } }}
    />
    {children}
  </MuiMenuItem>
);

export type { Props as CheckboxMenuItemProps };
export default CheckboxMenuItem;
